import { render, staticRenderFns } from "./phoneFeedbackDetail.vue?vue&type=template&id=15eece0c&scoped=true&"
import script from "./phoneFeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./phoneFeedbackDetail.vue?vue&type=script&lang=js&"
import style0 from "./phoneFeedbackDetail.vue?vue&type=style&index=0&id=15eece0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eece0c",
  null
  
)

export default component.exports